<template>
  <div class="vx-row match-height" id="creat-product">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('BasicInfo')" class="mt-2">
            <basic-info></basic-info>
          </vs-tab>
          <vs-tab :label="$t('TechnicalSpecifications')" class="mt-2">
            <technical-specifications></technical-specifications>
          </vs-tab>
          <vs-tab :label="$t('Gallery')" class="mt-2">
            <gallery></gallery>
          </vs-tab>
          <vs-tab label="گالری ویدیو" class="mt-2">
            <Videos></Videos>
          </vs-tab>
          <!--<vs-tab :label="$t('Events')">
              <events></events>
            </vs-tab>-->
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import BasicInfo from "./Edit/BasicInfo.vue";
import TechnicalSpecifications from "./Edit/TechnicalSpecifications.vue";
import Gallery from "./Edit/Gallery.vue";
import Videos from "./Edit/Videos.vue";
import Events from "./Edit/Events.vue";

import "../../assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  components: {
    BasicInfo,
    TechnicalSpecifications,
    Gallery,
    Events,
    Videos
  },
  methods: {
    ...mapActions({
      fetchSingle: "actualProduct/fetchSingle"
    })
  }
};
</script>
